
import { Prop } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';
import { CompanyClient, GarmentClient } from '@/services/Services';

@Options({})
export default class addLicenseModal extends Vue {

    @Prop() company: OM.Company;

    vm: OM.AddGarmentLicenseVM = new OM.AddGarmentLicenseVM();
    garments: OM.TextIdentifier[] = [];
    selectedGarments: OM.TextIdentifier[] = [];
    saving: boolean = false;
    saveFailed: boolean = false;

    created() {
        GarmentClient.getLicensableConfigurations()
        .then(x => this.garments = [...x].sort((a, b) => a.text.localeCompare(b.text)))

        this.vm.companyIdentifier = this.company.identifier;
    }

    async save() {
        if (this.disabled)
            return;

        this.saving = true;
        this.saveFailed = false;
        const expiresOn = this.vm.garmentLicense.expiresOn;
        const simultaneousAccessNumber = this.vm.garmentLicense.simultaneousAccessNumber;

        try {
            for (const garment of [...this.selectedGarments]) {
                const request = new OM.AddGarmentLicenseVM();
                request.companyIdentifier = this.vm.companyIdentifier;
                request.garmentLicense.garment = garment;
                request.garmentLicense.expiresOn = expiresOn;
                request.garmentLicense.simultaneousAccessNumber = simultaneousAccessNumber;
                await CompanyClient.addLicense(request);
                this.selectedGarments = this.selectedGarments.filter(x => x.identifier !== garment.identifier);
            }
            this.$emit('close');
        } catch {
            this.saveFailed = true;
        } finally {
            this.saving = false;
        }
    }

    get disabled(){
        return this.saving || !this.vm.garmentLicense.simultaneousAccessNumber || this.vm.garmentLicense.simultaneousAccessNumber <= 0 ||
            !this.vm.garmentLicense.expiresOn || this.selectedGarments.length === 0;
    }
    
}
